import styled from "styled-components";

import { useHover } from "@react-aria/interactions";
import { GoToPage } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Type } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { WebsiteTooltip } from "app/components/React/Tooltip/WebsiteTooltip/WebsiteTooltip";

import { StyledItemIcon } from "../../StyledComponents";

const ExternalLink = styled.a<{ $isVisible: boolean; $isIconHovered: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    transition: opacity 200ms ease;
    color: ${({ $isIconHovered }) =>
        $isIconHovered ? colorsPalettes.blue[400] : colorsPalettes.carbon[400]};
    flex-shrink: 0;
`;

interface IDomainWithTooltipLinkProps {
    domain: string;
    favicon: string;
}

export const DomainWithTooltipLink = ({ domain, favicon }: IDomainWithTooltipLinkProps) => {
    const { hoverProps: rowHoverProps, isHovered } = useHover({});
    const { hoverProps: iconHoverProps, isHovered: isIconHovered } = useHover({});

    return (
        <Flex
            alignItems="center"
            gap="8px"
            minWidth="0"
            width="100%"
            {...rowHoverProps}
        >
            <StyledItemIcon
                iconType={Type.Website}
                iconSrc={favicon}
            />
            <Flex
                inline
                alignItems="center"
                minWidth="0"
                maxWidth="100%"
                gap="4px"
            >
                <WebsiteTooltip
                    domain={domain}
                    mainDomainOnly={false}
                >
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[400]}
                        display="block"
                        whiteSpace="nowrap"
                        maxWidth="100%"
                        minWidth="0"
                        textOverflow="ellipsis"
                        overflow="hidden"
                        data-automation="domain-name"
                    >
                        {domain}
                    </Text>
                </WebsiteTooltip>
                <ExternalLink
                    href={`http://${domain}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    $isVisible={isHovered}
                    $isIconHovered={isIconHovered}
                    {...iconHoverProps}
                >
                    <GoToPage
                        size="xs"
                        color="currentColor"
                    />
                </ExternalLink>
            </Flex>
        </Flex>
    );
};
